
// import FormMixin from '@/mixins/formularioMixin.js'
// mixins: [FormMixin],
import store from '@/store/index.js'
import jsFormulario from "@/Utlidades/FormularioUtils.js";

export default {
  props: {
    value: {
    },
    titulo:{
      type:String,
      default:''
    },
    obligatorio:{
      type:Boolean,
      default: false
    },
    campo:{
      type:String,
      default : ''
    },
    editable: {         // espera un texto '1' '0', por que viene muchas veces de un axios y estos valores son texto hay
      type: String,
      default: ''
    },
    sPlaceHolder: {
      type: String,
      default: ''
    },
    sTooltip: {
      type: String,
      default: ''
    },
    error : {
      type: Boolean,
      default: false
    },
    bSubdominioTemporal:{       // Indica que se activa puente con subdominio temporal y debo pasar el param de pueste
      type: Boolean,           
      default: false            
    },
    aItems:{       // Indica que se activa puente con subdominio temporal y debo pasar el param de pueste
      type: Array,           
      default: () => { return [] }            
    },
    sCampoModificaA: {
      type: String,
      default: ''
    },
    sTabla: {
      type: String,
      default: ''
    },
    aParametros: {
      type: Array,
      default: () => []         // Listado de string que contiene parametros adicionales que se usan para realizar filtrado, este listado son campos existentes.
    },
    condicion: {
      type: String,
      default: ''
    },
  }, 
  data () {
    return {
      sInformacion : ''  , // Con esta variable trabajare la inforamción que se se muestra en el icono de info. Se llena en onValidarProps
      aReglas: [],
      aErrores:[],
      nContarErrores: 0
    }
  },
  mounted() {
    
    if (this.value !== '' && this.sCampoModificaA) this.$emit('ModificaA', this.sCampoModificaA, this.value)

    this.onValidarInfoIcon()
  },
  methods: {
    onValNoEspaciosCaracteres(v){
      return /^[a-zA-Z0-9.]+$/.test(v) || store.state.jsIdioma.oEquivalencias.msgSinEspaciosCarecteresEspeciales
    },
    onValMinCaracteres(v,nMin){
      if(v){
        return v.length >= nMin  || store.state.jsIdioma.oEquivalencias.lblMinimoCaracteres.replace('###', nMin)
      }else{
        return 0 >= nMin  || store.state.jsIdioma.oEquivalencias.lblMinimoCaracteres.replace('###', nMin)
      }
    },
    onCrearReglas(){
      const sReglas = this.onValidarProps('aReglas', '', this.condicion)
      if(sReglas) {
        const aReglas = sReglas.split(';')
        aReglas.forEach(sRegla => {
          const aReglaAsig = sRegla.split(',');
          switch (aReglaAsig[0]) {
            case 'onValNoEspaciosCaracteres':
              this.aReglas.push(jsFormulario.onValNoEspaciosCaracteres);
              this.bOcultarDetalle = false
            break;
            case 'onValMinCaracteres': {
              const nMin = (aReglaAsig[1]) ? parseInt(aReglaAsig[1]) : 10
              this.aReglas.push((v) => jsFormulario.onValMinCaracteres(v, nMin));
              this.bOcultarDetalle = false
            }
            break;
          
            default:
              break;
          }
        })
      }
    },
    onActualizarError(bError){
      //console.log(bError)
      this.esError = bError
    },
    onExtraerParametros() {
      let sParamsAdicionales = ''
      this.aParametros.forEach(sPar =>{
        if(sPar.includes('=')) sParamsAdicionales = sParamsAdicionales + `&${sPar}`
      })
      return sParamsAdicionales
    },
    onValidarProps (sIndex, ValorDefecto, sCondicion) {
      if(sCondicion === null || sCondicion === undefined) return ValorDefecto
      const aParametros = sCondicion.includes('|') ? sCondicion.split('|') : [sCondicion]
      if  (aParametros.length > 0) {
        let sValor = ValorDefecto
        aParametros.forEach(oItem => {
          if (oItem.includes(sIndex)) {
            const aParametroValor = oItem.split('=');
            sValor = (aParametroValor.length == 2) ? aParametroValor[1] : ValorDefecto
          }
        })

        return sValor
      } else {
        return ValorDefecto
      }
    },
    onValidarInfoIcon(){
      this.sInformacion = this.onValidarProps('sInformacion','',this.condicion)

    }
  },
  computed: {
    claseError() {
      return {
        'ntitlesdark--text' : !this.error,
        'red--text' : this.error 
      }
    }
  },
  watch: {
    valor(NewValor){
      if(typeof NewValor === "boolean"){
        this.$emit('input',(NewValor ? '1' : '0'))
      } else {
        this.$emit('input',NewValor)
      }

      if(this.sCampoModificaA) this.$emit('ModificaA', this.sCampoModificaA, NewValor)

      
    },    
    esError(){
      if(!this.esError) this.$emit('ErrorCampo', {
        campo : this.titulo,
        sMsgError : null
      })
    }

  },
}

// maxlength=30|